import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function sourceDataReducer(state = initialState.sourceData, action) {
  switch (action.type) {
    case types.GET_SOURCE_OF_LEAD_DATA_SUCCESS:
      return action.sourceData;
    default:
      return state;
  }
}
